import { render } from "./feedbackPage.vue?vue&type=template&id=93f93368"
import script from "./feedbackPage.vue?vue&type=script&lang=js"
export * from "./feedbackPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__